import log from 'salvo-lite/log'

class RegisterTags {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._labels = elem.querySelectorAll('label')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._labels.forEach(label => {
            label.addEventListener('click', e => {
                e.preventDefault()
                this._elem.querySelector('input[checked]').removeAttribute('checked')
                label.previousElementSibling.setAttribute('checked', '')
            })
        })
    }
}

export default RegisterTags



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RegisterTags.js